<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">My Profile</h3>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Update My Profile</h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form class="form-horizontal" id="profile-form" v-on:submit.prevent="updateProfile">
                  <fieldset class="form-group">
                    <label for="pic">Profile Picture<br /><div class="text-center"><img v-bind:src="pic" class="profile-pic" /></div></label>
                    <input type="file" ref="file" class="form-control" id="pic" v-on:change="updatePic()" />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="first_name">First Name*</label>
                    <input type="text" class="form-control" id="first_name" v-model="first_name">
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="last_name">Last Name*</label>
                    <input type="text" class="form-control" id="last_name" v-model="last_name">
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="last_name">Email*</label>
                    <input type="email" class="form-control" id="email" v-model="email">
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="cellphone">Cellphone*</label>
                    <input type="text" class="form-control" id="cellphone" v-model="cellphone" disabled="">
                    <small>Cellphone number is locked</small>
                  </fieldset>
                  <input type="hidden" v-model="device_identifier" />
                  <div class="alert alert-danger mb-2" role="alert" v-if="errorMsg">
                    <strong>Oh snap!</strong> {{errorMsg}}
                  </div>
                  <div class="alert alert-success mb-2" role="alert" v-if="successMsg">
                    <strong>Well done!</strong> {{successMsg}}
                  </div>
                  <div class="form-group text-center">
                    <button type="submit" class="btn btn-block btn-glow btn-secondary" v-on:click="scan">Scan QR Code</button><br />

                    <button type="submit" class="btn btn-block btn-glow btn-primary">Update Profile</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Update Password</h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form class="form-horizontal" id="password-form" v-on:submit.prevent="updatePassword">
                  <fieldset class="form-group">
                    <label for="password">Current Password*</label>
                    <input type="password" class="form-control" id="password" v-model="password">
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="new_password">New Password*</label>
                    <input type="password" class="form-control" id="new_password" v-model="new_password">
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="confirm_new_password">Confirm New Password*</label>
                    <input type="password" class="form-control" id="confirm_new_password" v-model="confirm_new_password">
                  </fieldset>
                  <div class="alert alert-danger mb-2" role="alert" v-if="errorMsg2">
                    <strong>Oh snap!</strong> {{errorMsg2}}
                  </div>
                  <div class="alert alert-success mb-2" role="alert" v-if="successMsg2">
                    <strong>Well done!</strong> {{successMsg2}}
                  </div>
                  <div class="form-group text-center">
                    <button type="submit" class="btn btn-block btn-glow btn-primary">Update Password</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'profile',
  data: function () {
    return {
      pic: '',
      first_name: '',
      last_name: '',
      email: '',
      cellphone: '',
      password: '',
      device_identifier: '',
      new_password: '',
      confirm_new_password: '',
      errorMsg: '',
      errorMsg2: '',
      successMsg: '',
      successMsg2: ''
    }
  },
  mounted: function () {
    var user = JSON.parse(localStorage.getItem('user'))

    this.pic = user.pic ? user.pic : 'images/portrait/default-user-profile.svg'
    this.first_name = user.parent.first_name
    this.last_name = user.parent.last_name
    this.email = user.email
    this.cellphone = user.parent.cellphone
    this.device_identifier = user.parent.device_identifier ? user.parent.device_identifier : ''
  },
  methods: {
    scan: function () {
      $.showLoading()
      var that = this

      // eslint-disable-next-line
      cordova.plugins.barcodeScanner.scan(
        function (result) {
          that.device_identifier = result.text
          that.updateProfile()
        },
        function (error) {
          alert('Scanning failed: ' + error)
          $.hideLoading()
        }, {
          preferFrontCamera: true, // iOS and Android
          showFlipCameraButton: true, // iOS and Android
          showTorchButton: true, // iOS and Android
          torchOn: false, // Android, launch with the torch switched on (if available)
          saveHistory: true, // Android, save scan history (default false)
          prompt: 'Place a barcode inside the scan area', // Android
          resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          formats: 'QR_CODE,PDF_417', // default: all but PDF_417 and RSS_EXPANDED
          disableAnimations: true, // iOS
          disableSuccessBeep: false // iOS and Android
        }
      )
    },
    updatePic: function () {
      var that = this

      $.showLoading()
      var file = this.$refs.file.files[0]
      var metadata = {
        'contentType': file.type
      }
      // eslint-disable-next-line
      var storageRef = firebase.storage().ref()

      storageRef.child('images/' + file.name).put(file, metadata).then(function (snapshot) {
        snapshot.ref.getDownloadURL().then(function (url) {
          that.pic = url
          $.hideLoading()
        })
      }).catch(function (error) {
        $.hideLoading()
        console.error('Upload failed:', error)
      })
    },
    updateProfile: function () {
      var that = this
      this.errorMsg = ''
      this.successMsg = ''

      var data = {
        token: localStorage.getItem('token'),
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        cellphone: this.cellphone,
        pic: this.pic,
        device_identifier: that.device_identifier
      }

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'basic/parent_profile_update',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          if (data.success === false) {
            that.errorMsg = data.message
          } else {
            that.successMsg = 'Profile Successfully Updated'

            var user = JSON.parse(window.localStorage.getItem('user'))

            user.pic = that.pic
            user.email = that.email
            user.name = that.first_name + ' ' + that.last_name
            user.parent.first_name = that.first_name
            user.parent.last_name = that.last_name
            user.parent.cellphone = that.cellphone
            localStorage.setItem('user', JSON.stringify(user))
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $.hideLoading()
          if (errorThrown === 'Unauthorized') {
            that.$router.push('/login')
          }
        }
      })
    },
    updatePassword: function () {
      this.errorMsg2 = ''
      this.successMsg2 = ''

      var that = this
      var user = JSON.parse(window.localStorage.getItem('user'))

      if (this.new_password !== this.confirm_new_password) {
        this.errorMsg2 = 'Confirmed password not the same as new password'
      }

      if (this.errorMsg2 === '') {
        var data = {
          username: user.username,
          password: this.password,
          new_password: this.new_password
        }

        $.ajax({
          beforeSend: function (xhr) {
            $.showLoading()
            if (window.localStorage.getItem('token')) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            }
          },
          complete: function () {
            $.hideLoading()
          },
          url: this.$config.apiUrl + 'basic/update_password',
          type: 'post',
          data: JSON.stringify(data),
          success: function (data) {
            if (data.success === false) {
              that.errorMsg2 = data.message
            } else {
              that.successMsg2 = 'Password Successfully Changed'
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            $.hideLoading()
            if (errorThrown === 'Unauthorized') {
              that.$router.push('/login')
            }
            that.errorMsg2 = 'Something went wrong, please try again later'
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.profile-pic {
  max-width:100px;
}
</style>
